import React from "react";

import { Article } from "../article";
import { Community } from "../community";
import { News } from "../news";
import { ForYou } from "../for-you";
import { localization } from "./config/localization";
import { commander } from "./commander";
import { generateRoute } from "./helper-generate-route";
import { AppView } from "./view";
import { useSnowplowContext } from "supercell-frontend-base/src/analytics/snowplow";

export const AppController = ({ sendCommand }) => {
    const { trackLinkClick } = useSnowplowContext();

    const routes = [
        generateRoute("/news/:id/:slug/:variant", Article),
        generateRoute("/news/:id/:slug", Article),
        generateRoute("/news/:id", Article),
        generateRoute("/community", Community),
        generateRoute("/community/:type/*", Community),
        generateRoute("/for-you/:level.html", ForYou),
        generateRoute("/news", News),
        generateRoute("/", News),
    ];

    const props = {
        commander: commander(sendCommand, trackLinkClick),
        localization,
        routes,
    };

    return <AppView {...props} />;
};
